module.exports = __webpack_public_path__ + "static/img/dialog-bg.6ec7a24e.png";